import { useApiMutation } from '@/modules/common';

import { CreateGcrBody, GcrUploadUrlData } from '../types';

export function useCreateGcrs() {
  const uploadUrlDataMutation = useApiMutation<void, GcrUploadUrlData>(
    '/gcrs/upload-url',
    {
      method: 'GET',
    }
  );

  const createGcrMutation = useApiMutation<CreateGcrBody>('/gcrs', {
    method: 'POST',
  });

  return {
    uploadUrlDataMutation,
    createGcrMutation,
  } as const;
}
